<mat-card class="pricing-card" [style.min-height]="cardMinimumHeightPx + 'px'">
    <div class="price-section">
        <h4 [innerHTML]="subscriptionProduct.title"></h4>
        <h2 [innerHTML]="subscriptionProduct.subtitle"></h2>
        <h1 [innerHTML]="subscriptionProduct.prettyPrice"></h1>
        <div class="month-label" [innerHTML]="subscriptionProduct.subscriptionFrequency"></div>
        <button *ngIf="showSignupButton" class="pricing-signup-button" mat-raised-button color="accent" gtagEvent trackOn="click" [action]="'sign_up_' + subscriptionProduct.signupType" category="account" (click)="signUpClicked(subscriptionProduct.signupType === 'planner')" [innerHTML]="subscriptionProduct.promptText"></button>
    </div>
    <div class="feature-list">
        <div class="feature-title">Features</div>
        <ul>
            <li *ngFor="let feature of subscriptionProduct.features" [ngClass]="feature.isPending ? 'pending-feature' : ''" [innerHTML]="getFeatureInnerText(feature)"></li>
        </ul>
    </div>
</mat-card>
